import { Button, Color, _decorator } from 'cc';

const { ccclass, property } = _decorator;

@ccclass('ButtonColorSet')
export default class ButtonColorSet {
    @property(Color)
    normal: Color = Color.WHITE.clone();
    @property(Color)
    pressed: Color = Color.WHITE.clone();
    @property(Color)
    hover: Color = Color.WHITE.clone();
    @property(Color)
    disabled: Color = Color.WHITE.clone();

    public apply(button: Button) {
        button.normalColor = this.normal;
        button.pressedColor = this.pressed ?? this.normal;
        button.hoverColor = this.hover ?? this.normal;
        button.disabledColor = this.disabled ?? this.normal;
        button.updateState();
    }
}
